// extracted by mini-css-extract-plugin
export default {"bannerTextPreview":"bannerTextPreview_bannerTextPreview__9MkKh","description":"bannerTextPreview_description__MKwy8","button":"bannerTextPreview_button__bIEtC"};